import type { Address } from "viem"

import { LcAddress } from "@/domains/core"
import { DomainEvent } from "@/domains/events"

export class GaugeAddedToRepositoryEvent extends DomainEvent {
  static readonly TYPE = "gauge.added-to-repository"
  readonly type = GaugeAddedToRepositoryEvent.TYPE
  constructor(public readonly gaugeAddress: LcAddress) {
    super()
  }
}

export class GaugeCreatedEvent extends DomainEvent {
  static readonly TYPE = "gauge.created"
  readonly type = GaugeCreatedEvent.TYPE
  constructor(
    public readonly poolAddress: Address,
    public readonly gaugeAddress: Address,
    public readonly bribeAddress: Address,
    public readonly creator: Address,
    public readonly transactionHash: string,
  ) {
    super()
  }
}

export class GaugeConnectedToMinimalPoolEvent extends DomainEvent {
  static readonly TYPE = "gauge.connected-to-minimal-pool"
  readonly type = GaugeConnectedToMinimalPoolEvent.TYPE
  constructor(
    public readonly gaugeAddress: LcAddress,
    public readonly poolAddress: LcAddress,
  ) {
    super()
  }
}

export class GaugeConnectedToClFarmEvent extends DomainEvent {
  static readonly TYPE = "gauge.connected-to-cl-farm"
  readonly type = GaugeConnectedToClFarmEvent.TYPE
  constructor(
    public readonly gaugeAddress: LcAddress,
    public readonly farmAddress: LcAddress,
  ) {
    super()
  }
}

export class GaugeVotedEvent extends DomainEvent {
  static readonly TYPE = "gauge.voted"
  readonly type = GaugeVotedEvent.TYPE
  constructor(
    public readonly gaugeAddress: Address,
    public readonly voter: Address,
    public readonly tokenId: bigint,
    public readonly weight: bigint,
    public readonly transactionHash: string,
  ) {
    super()
  }
}
